import * as Sentry from "@sentry/react";
import { ENVIRONMENT, SENTRY_DSN } from "./configs";

Sentry.init({
    environment: ENVIRONMENT,
    dsn: SENTRY_DSN,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            // Keep user input values masked in Sentry replays.
            maskAllInputs: true,
            unblock: [
                '[data-interview-controls] svg',
                '[data-interview-controls] img[src*="icon"]',
                '[data-interview-controls] img[src*="svg"]',
                '[data-interview-controls] img[src*=".svg"]',
            ],
        }),
        Sentry.replayCanvasIntegration(),
    ],

    tracesSampleRate: 1.0,
    replaysSessionSampleRate: ENVIRONMENT === 'prod' ? 1.0 : 0.0,
    replaysOnErrorSampleRate: 1.0,
    enabled: ENVIRONMENT !== 'local',
    ignoreErrors: [
        "No profile logo has been uploaded yet",
        "You are logged out, please login",
        "Network Error",
        "Conversation not found",
        "No token found"
    ]
});
